<template>
  <section class="co-bg-striped flex justify-center py-[3.25rem]">
    <div class="mr-3 flex sm:mr-6">
      <img
        src="~/assets/images/Te/TeCommon/Banner/PcBeginner/icon-pc-beginner.svg"
        alt="パソコン初心者アイコン"
        width="34"
        height="49"
        loading="lazy"
      >
    </div>
    <p class="m-0 text-center">
      <span class="co-display-9 font-bold">パソコンの基本的な操作に不安</span>
      <br>
      <span class="co-display-11">がある方は</span>
      <button
        class="co-btn-text hover:text-co-info-400 border-0 bg-transparent p-0 align-baseline"
        onclick="modal_pc_to_beginner.showModal()"
      >
        コチラ
      </button>
      <span class="co-display-11">をご確認ください</span>
    </p>
    <client-only>
      <Teleport to="body">
        <dialog
          id="modal_pc_to_beginner"
          class="modal"
        >
          <div class="modal-box">
            <!-- 右上の閉じるボタン -->
            <button
              class="btn btn-circle btn-ghost btn-sm absolute right-2 top-2"
              onclick="modal_pc_to_beginner.close()"
            >
              ✕
            </button>
            <!-- モーダルのコンテンツ -->
            <div class="te-modal-body py-6">
              <h5 class="co-display-11 mb-4 border-b pb-4 font-bold">
                PC基本操作の確認
              </h5>
              <h3 class="co-display-11 mb-4 mt-2 text-center font-bold">
                以下の操作に問題がないかご確認ください
              </h3>
              <ul
                class="te-alert mx-auto mb-0 block w-fit list-disc rounded px-6 py-5 text-left font-bold"
                style="list-style-position: inside"
              >
                <li class="mb-2">
                  ローマ字入力で文章を書ける
                </li>
                <li class="mb-2">
                  コピー＆ペーストができる
                </li>
                <li class="mb-2">
                  ファイルを移動させることができる
                </li>
                <li class="mb-2">
                  ファイル名を変更することができる
                </li>
                <li class="mb-2">
                  フォルダが作れる
                </li>
                <li class="mb-2">
                  ソフトのインストールができる
                </li>
                <li>Googleで検索ができる</li>
              </ul>
              <p class="mb-1 mt-4 text-center text-gray-700">
                上記の操作に不安がある方は、PC基本操作説明資料を<br class="hidden sm:inline">ご確認の上、コースにお申し込みください。
              </p>
              <div class="mt-6 text-center">
                <a
                  class="co-btn-ghost-white co-display-12 rounded-full bg-co-primary-500 text-co-gray-50"
                  href="/_nuxt/pdf/Te/pc-begginer.pdf"
                  target="_blank"
                  download="基本的なPC操作について.pdf"
                >PC基本操作説明資料をダウンロード</a>
              </div>
            </div>
          </div>
          <!-- モーダルの外側をクリックしたら閉じる -->
          <button
            class="modal-backdrop"
            onclick="modal_pc_to_beginner.close()"
          >
            close
          </button>
        </dialog>
      </Teleport>
    </client-only>
  </section>
</template>

<style scoped>
/* アラート */
.te-alert {
  color: #856404;
  background-color: #fff3cd;
  border-color: #ffeeba;
}
</style>
